import { connect } from "react-redux";
import { provideHooks } from "redial";
import CategoryPage from "./CategoryPage";
import {
  fetchCategory,
  getItemCount,
  hasFacets,
  getPageNumber
} from "../../state/modules/search";
import { setPageLoading } from "../../state/modules/page/actions";
import {
  setCategoryServerError,
  getCategoryServerError,
  getCategoryTitle,
  getCategoryBreadcrumbs
} from "../../state/modules/category";
import { parse } from "query-string";

import { getIsNewSearch } from "../../state/modules/search/selectors";
import {
  loadCategoryDetails,
  loadCategory
} from "../../state/modules/category/actions/loadCategoryDetails";
import { analyticsPageLoad } from "../../state/modules/analytics/actions";

export function mapStateToProps(state) {
  return {
    categoryError: getCategoryServerError(state),
    hasFacets: hasFacets(state),
    itemCount: getItemCount(state),
    isLoading: state.page.isLoading,
    title: getCategoryTitle(state),
    pageNumber: getPageNumber(state),
    breadcrumbs: getCategoryBreadcrumbs(state)
  };
}

const getCategory = ({
  dispatch,
  query,
  country,
  language,
  uuid,
  xSiteOrigin,
  isNewPage
}) =>
  isNewPage || SERVER
    ? [
        dispatch(
          loadCategoryDetails({
            query,
            country,
            language,
            uuid,
            xSiteOrigin
          })
        ),
        dispatch(loadCategory({ query, country, language, uuid, xSiteOrigin }))
      ]
    : [];

export const hooks = {
  fetch: ({
    dispatch,
    location,
    store,
    error,
    uuid,
    xSiteOrigin,
    isNewPage
  }) => {
    if (error) {
      return dispatch(setCategoryServerError(error));
    }
    const query = parse(location?.search);
    const state = store.getState();

    if (!getIsNewSearch(state) && !isNewPage) {
      return;
    }

    const {
      config: {
        country,
        locale: { language }
      }
    } = state;

    return Promise.all([
      dispatch(fetchCategory(uuid, xSiteOrigin, isNewPage)),
      ...getCategory({
        dispatch,
        query,
        country,
        language,
        uuid,
        xSiteOrigin,
        isNewPage
      })
    ])
      .catch(error => {
        dispatch(setCategoryServerError(error));
      })
      .finally(() => {
        dispatch(setPageLoading(false));
        if (isNewPage) {
          dispatch(analyticsPageLoad({ country: country.countryCode }));
        }
      });
  }
};

export default provideHooks(hooks)(
  connect(mapStateToProps, null)(CategoryPage)
);
